var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{class:{
            'required-field': _vm.field.isRequired,
        },attrs:{"label":_vm.field.label,"label-for":`id_${_vm.field._id}`}},[_c('div',{staticClass:"form-group custom-datepicker"},[_c('date-picker',{directives:[{name:"validate",rawName:"v-validate",value:({
                    required: _vm.field.isRequired,
                }),expression:"{\n                    required: field.isRequired,\n                }"}],staticClass:"form-control",class:{
                    'is-invalid': _vm.errors.has(_vm.field.label),
                },attrs:{"format":"DD/MM/YYYY","lang":"en","disabled":_vm.loading,"data-vv-name":_vm.field.label,"end-at":_vm.endAt},on:{"input":_vm.onInput},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_c('i',{class:[
                    {
                        'disable-input': false,
                    },
                    'icon-calendar',
                ]})],1),(_vm.note)?_c('p',{staticClass:"tax-instruction"},[_c('i',{staticClass:"icon-error_outline"}),_c('span',[_vm._v("\n                "+_vm._s(_vm.note)+"\n            ")])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }